import { render, staticRenderFns } from "./supply-chain_pc.vue?vue&type=template&id=72b95c2e&scoped=true&"
import script from "./supply-chain_pc.vue?vue&type=script&lang=js&"
export * from "./supply-chain_pc.vue?vue&type=script&lang=js&"
import style0 from "./supply-chain_pc.vue?vue&type=style&index=0&id=72b95c2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b95c2e",
  null
  
)

export default component.exports